import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useRef,
  Dispatch,
  SetStateAction
} from "react";
import { TypeProgram_metaWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
import { getProgramPrice, PricingAPIPayload, PricingAPIError } from "@2u-landing-pages/utils";

export const PricingApiContext = createContext({
  pricingApiValues: {} as PricingAPIPayload & PricingAPIError,
  setCallPricingApi: (() => {}) as Dispatch<SetStateAction<boolean>>,
  pricingApiLoading: false
});

export const PricingApiContextProvider: React.FC<{
  children: React.ReactNode;
  programMeta: TypeProgram_metaWithoutUnresolvableLinksResponse;
}> = ({
  children,
  programMeta,
}) => {
  const [pricingApiValues, setPricingApiValues] = useState({
    id: "",
    course: "",
    durationWeeks: 0,
    duration: "",
    effort: "",
    currency: "",
    price: "",
    display_price: "",
    regCloseDate: "",
    startDate: "",
    endDate: "",
    error: "",
  });
  const [callPricingApi, setCallPricingApi] = useState(false);
  const [pricingApiLoading, setPricingApiLoading] = useState(false);
  const apiCalled = useRef(false);

  const pgm = programMeta?.fields?.pricing_api_slug || "";

  useEffect(() => {
    // Make sure Pricing API only gets called once
    if (!apiCalled.current && callPricingApi) {
      apiCalled.current = true;

      if (pgm) {
        setPricingApiLoading(true);

        getProgramPrice(pgm, (data: PricingAPIPayload & PricingAPIError) => {
          setPricingApiValues(data);
          setPricingApiLoading(false);
        });
      } else {
        console.error("No Pricing API slug found");
      }
    }
  }, [pgm, callPricingApi]);

  const value = useMemo(
    () => ({
      pricingApiValues,
      setCallPricingApi,
      pricingApiLoading,
    }),
    [pricingApiValues, pricingApiLoading]
  );

  return <PricingApiContext.Provider value={value}>{children}</PricingApiContext.Provider>;
};
